import {Query, Store, StoreConfig} from "@datorama/akita"
import {ApiUserResult} from "app/Interface/Api/Client/ApiUser"
import produce from "immer"

@StoreConfig({name: 'root.user', resettable: true, producerFn: produce})
export class UserStore extends Store<ApiUserResult> {
  constructor() {
    super({
      loading: undefined,
      roles: [],
      chosenLayouts: []
    })
  }
}

export const rootUserStore = new UserStore()

class UserQuery extends Query<ApiUserResult> {
  constructor(protected store: UserStore) {
    super(store)
  }
}

export const userQuery = new UserQuery(rootUserStore)
